<template>
    <form class="brk-form-round brk-form-round-btn-inside-full w-100">
        <input type="text" :placeholder="$t('coupon.code')" v-model="coupon">
        <button class="btn btn-inside-out btn-lg border-radius-30 btn-shadow mx-0 my-0"
                data-brk-library="component__button" @click.prevent="checkCoupon">
            <span class="before">{{$t('payment.apply')}}</span><span class="text">{{$t('payment.apply')}}</span><span
                class="after">{{$t('payment.apply')}}</span>
        </button>
    </form>
</template>

<script>
    export default {
        mounted(){
            this.setLang();
        },

        props: ['discount'],

        data() {
            return {
                lang: '',
                coupon: '',
                data: '',
                errors: ''
            }
        },

        methods: {
            setLang() {
                this.lang = window.default_locale
                this.$i18n.locale = window.default_locale
            },

            checkCoupon(){
                axios.post('/api/v1/service/coupon', { coupon: this.coupon })
                    .then(response => {

                        this.data = response.data

                        Event.$emit('coupon-apply', response.data)

                    }, (error) => {
                        this.errors = error.response.data.errors
                        this.$toastr.e(this.$t('coupon.not_valid'))

                    });
            }
        }
    }
</script>
